import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { values } from 'd3';
import { TranslationService } from '@sdbn/common';
import { ArticleTypeAttributeGroup, ArticleTypeAttributeType, AttributeGroupUsage } from 'src/erp-articles/article-types/article-type.model';

@Component({
  selector: 'app-attribute-group',
  templateUrl: './attribute-group.component.html',
  styleUrls: ['./attribute-group.component.scss']
})
export class AttributeGroupComponent implements OnInit {

  private initialized = false;

  attributesFormGroup = new FormGroup({});

  _valuesMap: Map<string, string>;

  @Input() attributeGroup: ArticleTypeAttributeGroup;

  @Input() set valuesMap(valuesMap: Map<string, string>) {
    if (!this.initialized) {
      this.initialized = true;
      this._valuesMap = valuesMap;
      this.createFormFields();
      this.applyFormControlValueChangedListener();
    }
  }

  get valuesMap() {
    return this._valuesMap;
  }

  @Input() usage: AttributeGroupUsage;

  /** The parent FormGroup to join. */
  @Input() formGroup: FormGroup;

  constructor(public translationService: TranslationService) { }

  ngOnInit(): void {
    this.formGroup.addControl('attributeGroup-' + this.attributeGroup.id, this.attributesFormGroup);
  }

  private applyFormControlValueChangedListener() {
    this.attributesFormGroup.valueChanges.subscribe(values => {
      for (const attribute of this.attributeGroup.attributes) {
        const value = values['attribute_' + attribute.id];
        this.valuesMap.set(attribute.id + '', '' + value);
      }
    });
  }

  private createFormFields() {
    for (const attribute of this.attributeGroup?.attributes) {
      const validators = [];
      if (attribute.mandatory === true) {
        validators.push(Validators.required);
      }
      let value = null;
      if (attribute.type === ArticleTypeAttributeType.BOOLEAN) {
        value = this.getValueByAttributeId(attribute.id) === 'true';
      } else {
        value = this.getValueByAttributeId(attribute.id);
      }
      this.attributesFormGroup.addControl('attribute_' + attribute.id, new FormControl(value != null ? value : null, validators));
    }
  }

  private getValueByAttributeId(attributeId: number): string {
    return this.valuesMap.get(attributeId + '');
  }
}
